export const typeUpdateUser = '@user/update';

export interface IUserReducer {
   name: string;
}
